export { default as customMessageBox } from './message'


// WEBPACK FOOTER //
// ./src/mixins/index.js